export default "__VITE_ASSET__NjwI8Rzi__"